
    var riot = require('riot')
    //src: starling/src/tags/node-perspective-dot.html
riot.tag2('node-perspective-dot',
  '<node-perspective-annotation if="{!this.dummy}" perspective="{this.getPerspective()}" canvas="{this.canvas}" nodetag="{this.nodeTag}"></node-perspective-annotation> <i ref="dot" class="fa fa-circle p-dot" riot-style="color: {this.color}" onclick="{handleDotClick}" ondblclick="{handleDotClick}" onmouseenter="{handleMouseEnter}" onmouseleave="{handleMouseLeave}" oncontextmenu="{handleRightClick}"> <span class="target"></span> <i ref="shadow" class="fa fa-circle p-dot-shadow" riot-style="-webkit-text-stroke: 16px {this.color}"></i> </i>',
  'node-perspective-dot { margin: 1px; vertical-align: middle; cursor: pointer; display: inline-block; width: 12px; height: 12px; margin-right: -5px; position: relative; } node-perspective-dot node-perspective-annotation,[data-is="node-perspective-dot"] node-perspective-annotation{ position: absolute; } node-perspective-dot .p-dot,[data-is="node-perspective-dot"] .p-dot{ pointer-events: all; font-size: 15px; -webkit-text-stroke: 2px white; z-index: 11000; position: relative; } node-perspective-dot .p-dot-shadow,[data-is="node-perspective-dot"] .p-dot-shadow{ top: 0; z-index: -1; position: absolute; pointer-events: none; display: none; opacity: 0.5; } node-perspective-dot .p-dot:hover .p-dot-shadow,[data-is="node-perspective-dot"] .p-dot:hover .p-dot-shadow{ display: block; } node-perspective-dot i .target,[data-is="node-perspective-dot"] i .target{ position: absolute; bottom: 0; width: 10px; height: 40px; top: -12px; }',
  'ondblclick="{this.ignoreClick}" ref="main"', function(opts) {
'use strict';

var _this = this;

var _perspectivesUi = require('lib/perspectives-ui');

var _searchUi = require('lib/search-ui');

var _constants = require('lib/constants');

var _interactjs = require('interactjs');

var _interactjs2 = _interopRequireDefault(_interactjs);

var _util = require('lib/util');

var _escapeHtml = require('escape-html');

var _escapeHtml2 = _interopRequireDefault(_escapeHtml);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var self = this;
this.canvas = this.parent.canvas;
this.nodeTag = this.parent.parent;
this.nodeId = this.nodeTag.id;
this.dummy = this.opts.dummy;

if (!this.parent.opts.dummy) {
  this.canvas.nodePerspectiveDotTags[this.nodeTag.id + '-' + this.id] = this;
}

this.isPopoutAnnotation = function () {
  if (_this.canvas.annotationStyle == 'popout') {
    return true;
  }
};

this.freshen = function () {
  var perspective = store.getPerspective(_this.id);
  if (perspective) {
    var prevColor = _this.color;
    _this.color = perspective.color;

    if (prevColor !== _this.color) {
      _this.updateColorDisplay();
    }
  }
};

this.updateColorDisplay = function () {
  if (_this.refs && _this.refs.dot) {
    _this.refs.dot.style.color = _this.color;
    _this.refs.shadow.style.webkitTextStroke = '16px ' + _this.color;
  }
};

this.ignoreClick = function (e) {
  e.stopPropagation();
  e.preventDefault();
};

this.handleDotClick = function (e) {
  e.stopPropagation();
  _this.canvas.hidePopups();
  _this.getAnnotationTag().unsetHovered();
  if (!_this.isActive()) {
    _this.isPinned = true;
    _this.openAnnotation();
  } else {
    _this.isPinned = false;
    _this.closeAnnotation();
  }
};

this.handleMouseEnter = function () {
  var annotation = _this.getAnnotationTag();
  annotation.setHovered();
  if (document.activeElement === annotation.refs.title) return;
  _this.displayAnnotation();
};

this.handleMouseLeave = function () {
  var annotation = _this.getAnnotationTag();
  annotation.unshowAbove();
  annotation.unsetHovered();

  if (document.activeElement === annotation.refs.title) return;

  // don't dismiss annotation if perspective is pinned
  if (_perspectivesUi.pui.perspectiveIsActive(_this.id) && _this.getAnnotationTag()._getAnnotation()) {
    return;
  }
  _this.hideAnnotation();
};

this.getAnnotationTag = function () {
  return _this.canvas.nodePerspectiveAnnotations[_this.nodeTag.id + '-' + _this.id];
};

this.openAnnotation = function () {
  _this.getAnnotationTag().openAnnotation();
};

this.hideAnnotation = function () {
  _this.getAnnotationTag().hideAnnotation();
};

this.closeAnnotation = function () {
  _this.getAnnotationTag().closeAnnotation();
};

this.displayAnnotation = function () {
  var annotationTag = _this.getAnnotationTag();
  annotationTag.showAbove();
  annotationTag.displayAnnotation();
};

this.isActive = function () {
  return _perspectivesUi.pui.isActiveAnnotation(_this.id, _this.nodeTag.id);
};
this.setActive = function (bool) {
  _perspectivesUi.pui.setActiveAnnotation(_this.id, _this.nodeTag.id, bool);
};
this.getPerspective = function () {
  return store.getPerspective(_this.id);
};

this.showDotAnnotation = function () {
  var perspective = store.getPerspective(_this.id);
  if (perspective && _perspectivesUi.pui.perspectiveIsActive(_this.id) && perspective.getAnnotation(_this.nodeTag.id) || _this.getAnnotationTag() && _this.getAnnotationTag().isActive()) {
    return true;
  }
  return false;
};

this.hasPerspectiveAnnotation = function () {
  var perspective = store.getPerspective(_this.id);
  if (perspective && perspective.getAnnotation(_this.nodeTag.id)) {
    return true;
  }
  return false;
};

this.getShuttledAnnotation = function (perspectiveId) {
  if (!perspectiveId) {
    console.error('missing perspectiveId');
  }
  return _this.refs.main.querySelector('.annotation[data-id="' + perspectiveId + '"]');
};

this.handleRightClick = function (e) {
  if (!e.altKey) {
    e.preventDefault();
    e.stopPropagation();
    _this.canvas.rightClickMenu.summon({
      x: e.clientX,
      y: e.clientY,
      nodePerspectiveDot: _this
    });
  }
};

this.on('mount', function () {
  _this.mounted = true;
  _this.freshen();
});

this.freshen();
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('node-perspective-dot')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/node-perspective-dot.html
// module id = 644
// module chunks = 0